import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Faq, FaqAnswer } from '../_models/faq/faq.model';
import { ToastService } from '../_services';
import { FaqService } from '../_services/faq/faq.service';
import { FaqModalComponent } from './faq-modal/faq-modal.component';

@Component({
    selector: 'faq-component',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.css'],
    standalone: false
})
export class FaqComponent implements OnInit {
  @Input() showHeader: boolean = true;

  public faqs: Array<Faq> = new Array<Faq>();

  constructor(
    public dialog: MatDialog,
    private toast: ToastService,
    private faqService: FaqService
    ) { }

  ngOnInit() {
    let answer1 = new FaqAnswer();
    answer1.type = "Text";
    answer1.order = 1;
    answer1.body = "Answer 1";

    let answer2 = new FaqAnswer();
    answer2.type = "Text";
    answer2.order = 2;
    answer2.body = "Answer 2";

    let answer3 = new FaqAnswer();
    answer3.type = "Text";
    answer3.order = 3;
    answer3.body = "Answer 3";

    let answer4 = new FaqAnswer();
    answer4.type = "Text";
    answer4.order = 4;
    answer4.body = "Answer 4";

    let answer5 = new FaqAnswer();
    answer5.type = "Text";
    answer5.order = 5;
    answer5.body = "Answer 5";

    let faq1 = new Faq();
    faq1.title = "FAQ 1";
    faq1.order = 1;
    faq1.answers = new Array<FaqAnswer>();
    faq1.answers.push(answer1, answer2, answer3);

    let faq2 = new Faq();
    faq2.title = "FAQ 2";
    faq2.order = 2;
    faq2.answers = new Array<FaqAnswer>();
    faq2.answers.push(answer1, answer2, answer3, answer4, answer5);

    let faq3 = new Faq();
    faq3.title = "FAQ 3";
    faq3.order = 3;
    faq3.answers = new Array<FaqAnswer>();
    faq3.answers.push(answer1);

    let faq4 = new Faq();
    faq4.title = "FAQ 4";
    faq4.order = 4;
    faq4.answers = new Array<FaqAnswer>();
    faq4.answers.push(answer1, answer3);

    let faq5 = new Faq();
    faq5.title = "FAQ 5";
    faq5.order = 5;
    faq5.answers = new Array<FaqAnswer>();
    faq5.answers.push(answer1, answer4, answer5);

    let faq6 = new Faq();
    faq6.title = "FAQ 6";
    faq6.order = 6;
    faq6.answers = new Array<FaqAnswer>();
    faq6.answers.push(answer1, answer2, answer3, answer4);

    this.faqs.push(faq1, faq2, faq3, faq4, faq5, faq6);
  }

  public openFaq(): void {

  }

  public showModalTest(): void {
    const dialogRef = this.dialog.open(FaqModalComponent, {
      data: { area: "Test", issue: "Test" },
      panelClass: 'my-dialog'
    });
    dialogRef.afterClosed().subscribe((confirm: boolean) => {
      this.toast.info("FAQ modal closed");
    });
  }

}
